import useMartyContext from 'hooks/useMartyContext';
import { CONTROL_LEFT_IN_STOCK_4, N_LEFT_IN_STOCK_10, N_LEFT_IN_STOCK_4 } from 'constants/products';

import css from 'styles/components/common/lowStockLabel.scss';

const LowStockLabel = ({ label = 'Low Stock', hydraLowStockAssignment, onHand }) => {
  const { testId } = useMartyContext();
  const isLessThan4 = onHand <= 4;

  if ((hydraLowStockAssignment === N_LEFT_IN_STOCK_4 && isLessThan4) || hydraLowStockAssignment === N_LEFT_IN_STOCK_10) {
    return (
      <p className={css.lowStockLabel} data-test-id={testId('lowStockLabel')} aria-label="Low stock">
        {onHand} left in stock
      </p>
    );
  }

  return (
    hydraLowStockAssignment === CONTROL_LEFT_IN_STOCK_4 &&
    isLessThan4 && (
      <p className={css.lowStockLabel} data-test-id={testId('lowStockLabel')} aria-label="Low stock">
        {label}
      </p>
    )
  );
};

export default LowStockLabel;
